// Navigation constants
export const MAX_CLIENTS_IN_DROPDOWN = 10;

// Pagination constants  
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_OFFSET = 0;
export const MID_SEARCH_PAGE_SIZE = 100;
export const MAX_SEARCH_PAGE_SIZE = 200;